<section class="simulator-container" id="simulator">
	<section class="simulator-container__simulator">
		<h2 class="simulator-container__title">
			Conoce cuánto <span>ganarás</span> con
			<p>inver<span>+</span></p>
		</h2>
		<section class="simulator-container__input">
			<label for="amount" class="simulator-container__subtitle"
				>Ingresa el monto que deseas invertir</label
			>
			<cmv-range-input
				[amount]="amountToInvest"
				[mininumAmount]="15000"
				[maximumAmount]="maximumAmount"
				[isDecrementButtonDisable]="isGettingReturnOfInvestment"
				[isIncrementButtonDisable]="isGettingReturnOfInvestment"
				[isManualChangeDisable]="isGettingReturnOfInvestment"
				[jump]="jumpAmount"
				(rangeAmountChange)="onManualAmountChange($event)"></cmv-range-input>
		</section>
		<span class="simulator-container__message"
			>* Monto mínimo de inversión $15,000</span
		>
		<section class="simulator-container__results">
			<ul
				[ngClass]="{
					'--with-data': returnOfInvesmentResults.length > 0
				}">
				<li
					mode="mobile"
					*ngFor="let returnOfInvesment of returnOfInvesmentResults"
					[attr.value]="returnOfInvesment.returnOfInvestment | currency"
					[attr.days]="returnOfInvesment.period"
					[ngStyle]="{
						height:
							'calc(' +
							returnOfInvesment.graphicHeight +
							'% + var(--default-size))'
					}">
					<span>{{ returnOfInvesment.rate }}%</span>
				</li>
			</ul>
		</section>

		<span class="simulator-container__message">
			* Rendimiento estimado de acuerdo al plazo de inversión
		</span>
	</section>
</section>
